import React, { useMemo, useState } from 'react';
import { FormControl, InputLabel } from '@material-ui/core';
import { praiasAppData } from '@data/game.infos';
import { ContentArea } from '@styles/common';
import { KicksComboBox, KicksSelect } from '@screens/kicks/kicks.styles';
import KicksList from './kicks.list';

interface GameIDataProps {
  app?: string;
}

const Kicks = () => {
  const [app, setGameApp] = useState(praiasAppData[0]);

  const listProps = useMemo<GameIDataProps>(() => ({ app }), [app]);

  function handleGameAppChange(e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown; type?: string; checked?: boolean }>) {
    setGameApp(e.target.value as string);
  }

  return (
    <ContentArea>
      <KicksComboBox>
        <FormControl>
          <InputLabel id='gameApp'>Praia</InputLabel>
          <KicksSelect native labelId='Game App' id='gameApp' inputProps={{ name: 'gameApp' }} onChange={handleGameAppChange} value={app}>
            {praiasAppData.map((v) => (
              <option key={v} value={v}>
                {v}
              </option>
            ))}
          </KicksSelect>
        </FormControl>
      </KicksComboBox>
      <KicksList {...listProps} />
    </ContentArea>
  );
};

export default Kicks;
